import { MortgagePreferences, RepaymentMethod } from "models/ApplicationSummaryEnhanced"
import React from "react"

interface RepaymentMethodCopyProps {
  preference: MortgagePreferences["repaymentMethod"]
}
export const RepaymentMethodCopy = ({ preference }: RepaymentMethodCopyProps) => {
  switch (preference.method) {
    case RepaymentMethod.Repayment:
      return (
        <>
          A <strong>repayment mortgage</strong> has been recommended because{" "}
          {preference.customReason}
        </>
      )
    case RepaymentMethod.InterestOnly:
      return (
        <>
          An <strong>interest-only mortgage</strong> has been recommended because{" "}
          {preference.customReason}
        </>
      )
    case RepaymentMethod.PartAndPart:
      return (
        <>
          A <strong>part and part mortgage</strong> has been recommended because{" "}
          {preference.customReason}
        </>
      )
    default:
      return null
  }
}
